module.exports = __webpack_public_path__ + "static/media/ios-pricetag.a80b8a27.svg";